<template>
  <nav class="navbar navbar-fixed-top navbar-default">
    <div class="container">
      <div class="navbar-header">
        <a class="navbar-brand" v-link="{ path: '/' }"><img class="techcar-mark" src="/public/favicons/favicon-16x16.png"/></a>
        </div>
      </div>
    </div>
  </nav>
  <div class="container">
    <div class="jumbotron">
      <h1>Error 404</h1>
      <h2>Page not found</h2>
      <p>The page you requested <a v-link="{ path: $route.path }">{{ $route.path }}</a> could not be found.</p>
      <p>Please ensure you entered the correct URL or try navigating home</p>
      <p><a class="btn-default btn-lg" v-link="{ path: '/' }" role="button">Return home</a></p>
    </div>
  </div>
</template>

<script>
export default{
  data: function () {
    return {
    }
  },
  ready: function () {
  }
}
</script>



// WEBPACK FOOTER //
// 404.vue?180d2b70